export default __webpack_public_path__ + "static/media/172g.35a1a19e.svg";